import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = { id: "main_slide" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "inner" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<h2>스마트 안전게이트 원격 관제시스템<p>IoT Safety Gate Remote Control System</p></h2><h3>집중호우 시 인명피해와 재산손실을 신속하게 예방합니다.</h3><p class=\"txt\"> 지구온난화의 영향으로 집중호우 피해는 계속 커지고 있습니다. 빌딩 지하주차장의 침수, 급격한 하천의 수위 상승 등은 인명과 재산에 막대한 피해를 발생시킵니다. 또한 이러한 피해는 순식간에 일어납니다.<br><br> 스마트 안전게이트 원격 관제시스템은 <b>사람 또는 차량의 진출입로</b>(아파트, 빌딩, 주차장, 하천, 산책로 등)에 <b>진출입 게이트와 차수판을 설치</b>하고, 네트워크로 연결된 관제소의 관제시스템을 통해 <b>원격에서 실시간으로 모니터하고 제어</b>할 수 있는 시스템입니다.<br><br> 스마트 안전게이트 원격 관제시스템의 도입으로 급격한 집중호우 시 안전게이트 개폐 시간을 단축하여 많은 공공기관과 기업빌딩 및 개인 사유지의 인명과 재산의 피해를 예방할 수 있습니다. </p>", 3)
const _hoisted_10 = { class: "img_box" }
const _hoisted_11 = { class: "img" }
const _hoisted_12 = ["href", "onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "스마트 안전게이트", -1)
const _hoisted_15 = { class: "img" }
const _hoisted_16 = ["href", "onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "원격 관제시스템", -1)
const _hoisted_19 = {
  class: "modal_wrap img_modal",
  ref: "imgModalRef"
}
const _hoisted_20 = { class: "modal" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn_close",
  onclick: "closeModal();"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "blind" }, "닫기")
], -1)
const _hoisted_22 = ["src"]


import { ref } from "vue";

const __default__ = {
  name: "ClientMain",
  data() {
    return {
      img_modal_src: ref("")
    };
  },
  mounted() {
    window.mainSlideInit();
  },
  methods: {
    openImageModal: function(src) {
      this.$refs.imgModalRef.setAttribute("style", "display: block;");
      this.img_modal_src = src;
    }
  }
};
import gate_01 from "@/assets/images/pages/@temp_gate01_1200_800.jpg";
import gate_02 from "@/assets/images/pages/@temp_gate02_1200_800.jpg";
import gate_03 from "@/assets/images/pages/@temp_gate03_1200_800.jpg";
import img_safety_date from "@/assets/images/pages/img_photo01.jpg";
import img_system from "@/assets/images/pages/img_photo02.jpg";


export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

const slideItem = {
  type: Array,
  data: [gate_03, gate_01, gate_02, gate_03, gate_01, gate_02]
};

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slideItem.data, (imgSrc, index) => {
          return (_openBlock(), _createElementBlock("button", {
            class: "slide_item",
            key: index,
            onClick: $event => {_ctx.openImageModal(imgSrc);}
          }, [
            _createElementVNode("img", {
              src: imgSrc,
              alt: (index+1) + "번째 슬라이드"
            }, null, 8, _hoisted_4)
          ], 8, _hoisted_3))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_router_link, {
                to: "/smartGate",
                custom: ""
              }, {
                default: _withCtx(({href, navigate}) => [
                  _createElementVNode("a", {
                    href: href,
                    onClick: navigate
                  }, [
                    _createElementVNode("img", {
                      src: _unref(img_safety_date),
                      alt: "시공 이미지"
                    }, null, 8, _hoisted_13),
                    _hoisted_14
                  ], 8, _hoisted_12)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: "/system",
                custom: ""
              }, {
                default: _withCtx(({href, navigate}) => [
                  _createElementVNode("a", {
                    href: href,
                    onClick: navigate
                  }, [
                    _createElementVNode("img", {
                      src: _unref(img_system),
                      alt: "시스템 이미지"
                    }, null, 8, _hoisted_17),
                    _hoisted_18
                  ], 8, _hoisted_16)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("img", {
          class: "img_main",
          src: _ctx.img_modal_src,
          alt: "슬라이드 이미지"
        }, null, 8, _hoisted_22)
      ])
    ], 512)
  ], 64))
}
}

})